/**
 * Vite entry point for SpecForma renderer.
 *
 * Strategy: expose React/ReactDOM as globals first, then import all legacy
 * JSX/JS files as side-effect modules. They define window.* globals which
 * other files consume. This preserves the existing architecture while
 * enabling module-based bundling.
 *
 * Each file will be incrementally converted to proper imports in later phases.
 */
// Install the browser bridge BEFORE anything reads window.api (no-op in Electron).
import './lib/webApiShim';
import React from 'react';
import ReactDOM from 'react-dom/client';

// Expose React as globals — legacy JSX files destructure from global React
(window as any).React = React;
(window as any).ReactDOM = ReactDOM;

// Phase 2 shim: legacy files will be imported in dependency order below.
// They read/write window globals. This is intentional and temporary.

// --- Shared data & utils (plain JS, loaded first) ---
import './constants';
import './utils';
import './services/specService';

// --- Page components (JSX, order doesn't matter since they're called by name) ---
import './pages/Home';
import './pages/Projects';
import './pages/SpecLibrary';
import './pages/BlockEditor';
import './pages/AddSpecs';
import './pages/OrganizationsPage';
import './pages/TeamPage';
import './pages/TimeTrackingPage';

// --- Shared UI components (must load before app.jsx) ---
import './components/TokenComponents';
import './components/EditorComponents';

// --- Main app (loads last, mounts to #root) ---
import './app';
